import * as React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Form, FormProps } from '../form/Form';
import Icons from "../mon-compte/Icons";
import PasswordInfosForm from "./PasswordInfosForm";
import {getShopInfosInStorage} from "../cart/ShopInfos";
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';


class PasswordResetForm extends Form<TranslationProps & FormProps, Record<string, any>> {
  private displayPasswordInfos: boolean;
  private passwordInfos: any;
  private featurePassword: boolean | any;
  private showHidePassword: boolean;
  private shopInfos: Record<string, unknown>;

  constructor(props: TranslationProps) {
    super(props);
    this.displayPasswordInfos = false;
    this.shopInfos = getShopInfosInStorage();
    this.featurePassword = this.shopInfos?.motdepasse_robuste;
    if(this.featurePassword === undefined) {
      this.featurePassword = document.getElementById('containerChangePassword')?.getAttribute('data-feature');
    }
    this.showHidePassword = false;
    this.passwordInfos = {};
    this.state = {
      majLockMode: false,
      majLockModeConf: false
    }
  }

  componentDidMount() {
    this.featurePassword = this.shopInfos?.motdepasse_robuste;
    if(this.featurePassword === undefined) {
      this.featurePassword = document.getElementById('containerChangePassword')?.getAttribute('data-feature');
    }
  }

  protected handleValidate(oldValues: any, oldErrors: any, values: any): any {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      this.emitValidating(true, false);
      const errors: any = {};

      if (this.featurePassword && values.password == "") {
        if(this.verifPassword(values.password)) {
          errors.password = true;
        }
      } else if (!values.password) {
        errors.password = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      } else if (!this.featurePassword) {
        if(values.password.length < 8) {
          errors.password = 'Le mot de passe doit comporter au moins 8 caractères';
        }
      } else if (this.featurePassword && values.password) {
        if(this.verifPassword(values.password, true)) {
          errors.password = true;
        }
        this.displayPasswordInfos = true;
      }

      if (!values.confPassword) {
        errors.confPassword = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      } else if (values.confPassword !== values.password) {
        errors.confPassword = this.props.textsContent?.['AUTH_ERROR_MATCHING_PASSWORD'] ?? 'Les mots de passe ne correspondent pas';
      }

      this.emitResult(values, errors, resolve, reject);
    });
  }

  private verifPassword (password: string, returnValue: boolean = false) : void | boolean {
    let checkBoxLength = false;
    let checkBoxMaj = false;
    let checkBoxMin = false;
    let checkBoxChiffre = false;

    if(password.length >= 8 && password.length <= 30) {
      checkBoxLength = true;
    }
    if(password.match(/[A-ZÀ-ÖØ-Ý]/)) {
      checkBoxMaj = true;
    }
    if(password.match(/[a-zà-öø-ÿ]/)) {
      checkBoxMin = true;
    }
    if(password.match(/[0-9]/)) {
      checkBoxChiffre = true;
    }

    if((!checkBoxLength || !checkBoxMaj || !checkBoxMin || !checkBoxChiffre) && returnValue) {
      return true;
    }

    this.passwordInfos = {
      "checkBoxLength":checkBoxLength,
      "checkBoxMaj":checkBoxMaj,
      "checkBoxMin":checkBoxMin,
      "checkBoxChiffre":checkBoxChiffre
    };
  }

  private onShowHidePassword(id: string) {
    this.showHidePassword = !this.showHidePassword;
    const password : any = document.getElementById(id);
    if(password) {
      password.setAttribute('type', this.showHidePassword ? "text" : "password");
    }
  }

  private onResetPassword(id: string) {
    const password : any = document.getElementById(id);
    if(password) {
      password.setAttribute('value', '');
      password.value = '';
    }
  }

  private onCapsLockMode(event: any, name: string) {
    const value = name == 'majLockMode' ? this.state.majLockMode : this.state.majLockModeConf;
    if(event.keyCode == 20) {
      this.setState({
        [name]: !value
      });
    }
  }

  protected formRender(isSubmitting: boolean, values: any, errors: any): any {
    if(((values.password || values.password == "") && errors.password) && this.featurePassword) {
      this.verifPassword(values.password);
    }

    if(this.featurePassword === undefined) {
      this.featurePassword = this.shopInfos?.motdepasse_robuste;
    }

    const renderRemoveAndEyeIcons = (id: string) => {
      return (
          <>
            <div onClick={() => { this.onResetPassword(id);
              if(id == 'password') {
                values.password = '';
              } else if (id == 'confPassword') {
                values.confPassword = '';
              }
              this.handleValidate(values, errors, values).then(() => { return; }).catch(function () { return; })}}
                 className={"resetPasswordForm"}>
              <Icons
                  icon="close" size={30} title={this.props.textsContent?.['AUTH_ICON_REMOVE_PASSWORD'] ?? "Retirer le mot de passe"}/>
            </div>
            <div onClick={() => { this.onShowHidePassword(id); }} className={"eyePasswordForm"}>
              <Icons
                  icon="remove_red_eye" size={20} title={this.props.textsContent?.['AUTH_ICON_EYE_PASSWORD'] ?? "Afficher/Masquer le mot de passe"}/>
            </div>
          </>
      );
    }

    const renderMajLockInfo = () => {
      return (
          <span className={"capsLockInfos"}>{this.props.textsContent?.['AUTH_MAJ_LOCKED'] ?? "Majuscules activées"}</span>
      );
    }

    const renderPasswordInput = () => {
      return (
          <>
            <label htmlFor={'password'}>{this.props.textsContent?.['AUTH_RESET_PASSWORD_LABEL_PASSWORD'] ?? 'Nouveau mot de passe :'}</label>
            <div className={"inputPasswordForm"}>
              <Field placeholder={this.props.textsContent?.['AUTH_NEW_PASSWORD'] ?? 'Mot de passe'} type={'password'} autoComplete="off"
                     name="password" className="inputStyle w100 h35 pa05" id={'password'}
                     onKeyUp={(e:any) => this.onCapsLockMode(e, 'majLockMode')}
                     style={{ borderColor:  values?.password?.length > 0 && errors.password ? 'red' : ''}}
              />
              {values?.password?.length > 0 && renderRemoveAndEyeIcons('password')}
            </div>
            {this.state.majLockMode && renderMajLockInfo()}
            {this.displayPasswordInfos ? <PasswordInfosForm lstCheckbox={this.passwordInfos} isResetForm={true} /> : null}
          </>
      );
    }

    const renderConfirmPasswordInput = () => {
      return (
          <>
            <label htmlFor={'confPassword'} className={'margin-top-1'}>{this.props.textsContent?.['AUTH_RESET_PASSWORD_LABEL_PASSWORD_CONFIRM'] ?? 'Confirmation du mot de passe :'}</label>
            <div className={"inputPasswordForm"}>
              <Field placeholder={this.props.textsContent?.['AUTH_NEW_CONFIRM_PASSWORD'] ?? 'Confirmation mot de passe'}  autoComplete="off" type="password"
                     name="confPassword" className={"inputStyle w100 h35 pa05"} id={'confPassword'}
                     onKeyUp={(e:any) => this.onCapsLockMode(e, 'majLockModeConf')}
                     style={{ borderColor:  values?.confPassword?.length > 0 && errors.confPassword ? 'red' : ''}}
              />
              {values?.password?.length > 0 && renderRemoveAndEyeIcons('confPassword')}
            </div>
            {this.state.majLockModeConf && renderMajLockInfo()}
            <ErrorMessage name="confPassword" component="div" className="errorMessageReact" />
          </>
      );
    }

    return (
      <div className={"resetDivPasswordForm"}>
        {this.featurePassword ? renderPasswordInput() :
            <>
              <Field placeholder={'Mot de passe'} type="password" name="password" className="inputStyle form-control"  />
              <ErrorMessage name="password" component="div" className="errorMessageReact" />
            </>
        }
        {this.featurePassword ? renderConfirmPasswordInput() :
            <>
              <Field placeholder={'Confirmation mot de passe'} type="password" name="confPassword" className="inputStyle form-control mt-4" />
              <ErrorMessage name="confPassword" component="div" className="errorMessageReact" />
            </>
        }
        {(this.props.internalSubmitBtn || false) &&
        <button type="submit" disabled={isSubmitting}>
          Connexion
        </button>
        }
      </div>
    );
  }
}

export default WithTranslation(PasswordResetForm, 'AUTH_TUNNEL');
